import { useState } from "react";
import { updateDoc } from "firebase/firestore";
import { NavSurround } from "./NavSurround";
import { getUserRef, useCurrentUserSnapshot, deleteAccount } from "hooks/useAccount";
import { Header } from "./Forms/Header";
import { NameForm } from "./Forms/NameForm";
import { EmailForm } from "./Forms/EmailForm";
import { useString } from "providers/LocalisationProvider";
import { ConfirmDeleteAccountModal } from "./Modals/ConfirmDeleteAccountModal";
import { UserKeys } from 'fixit-shared/FirestoreKeys';

export const UserSettings = (props) => {
  const user = useCurrentUserSnapshot();
  const [passwordResetRequested, setPasswordResetRequested] = useState(false);
  const [passwordResetError, setPasswordResetError] = useState("");
  const [showDeleteAccountConfirmation, setShowDeleteAccountConfirmation] = useState(false);
  const authService = props.authService;

  const onNameChange = (displayName) => {
    updateDoc(getUserRef(user.id), { [UserKeys.displayName]: displayName });
  };

  const onEmailChange = (email) => {
    updateDoc(getUserRef(user.id), { [UserKeys.email]: email });
  };

  const resetPassword = async () => {
    try {
      if(passwordResetRequested) return;
      setPasswordResetError("");
      setPasswordResetRequested(true);
      await authService.resetPassword(user.email);
    } catch (error) {
      setPasswordResetError(error.message);
      setPasswordResetRequested(false);
    }
  };
  
  const resetPasswordString = useString("sign_in_reset");
  const resetPasswordRequestedString = useString("sign_in_reset_instructions", { email: user?.email });
  const deleteAccountString = useString("delete_account");

  if (!user) return null;

  return (
    <NavSurround
      authService={props.authService}
      telemetryService={props.telemetryService}
      currentPage="settings"
    >
      <Header user={user} />
      <div className="settings columns">
        <div className="column details">
          <NameForm
            onChange={onNameChange}
            defaultName={user.displayName}
          />
          <EmailForm onChange={onEmailChange} defaultEmail={user.email} />
          <div className="separator" />
          <button
            className="button accent full-width margin-y"
            onClick={resetPassword}
            disabled={passwordResetRequested}
          >
            {resetPasswordString}
          </button>
          <button
            className="button danger full-width margin-y"
            onClick={() => setShowDeleteAccountConfirmation(true)}
          >
            {deleteAccountString}
          </button>
          <p className="text-danger">
            {passwordResetRequested && resetPasswordRequestedString}
          </p>
          <p className="text-danger">
            {passwordResetError}
          </p>
        </div>
      </div>
      <ConfirmDeleteAccountModal
        isOpen={showDeleteAccountConfirmation}
        onClose={() => setShowDeleteAccountConfirmation(false)}
        onDeleteAccount={deleteAccount}
      />
    </NavSurround>
  );
};
